export default __webpack_public_path__ + "assets/ellipse-rb.svg";